import { Dic } from '$utils'
export const alarmOptions = function(that) {
  return {
    group: [
      {
        label: that.$t('historyAlarm.title.SnapshotPreview'),
        column: []
      },
      {
        label: that.$t('historyAlarm.title.alarmDetail'),
        column: [
          {
            label: that.$t('historyAlarm.title.alarmName'),
            prop: 'alarmId',
            span: 12
          },
          {
            label: that.$t('historyAlarm.title.alarmType'),
            prop: 'alarmType',
            dicData: Dic.find('SENU004005'),
            span: 12
          },
          {
            label: that.$t('historyAlarm.title.alarmLevel'),
            prop: 'alarmLevel',
            dicData: Dic.find('SENU017'),
            span: 12
          },
          {
            label: that.$t('historyAlarm.title.alarmTime'),
            prop: 'alarmTime',
            span: 12
          },
          {
            label: that.$t('historyAlarm.title.alarmLoca'),
            prop: 'groupName',
            span: 24
          },
          {
            label: that.$t('historyAlarm.title.videoPlayback'),
            prop: 'alarmDevId',
            slot: true,
            span: 24
          }
        ]
      },
      {
        label: that.$t('historyAlarm.title.dealWith'),
        column: [
          {
            label: that.$t('historyAlarm.title.Processingpers'),
            prop: 'modifier',
            span: 24
          },
          {
            label: that.$t('historyAlarm.title.ProcessingDes'),
            prop: 'processDesc',
            span: 24
          }
        ]
      }
    ]
  }
}
